module.exports = __webpack_public_path__ + "img/comments-question.1bbeddbd.svg";